import React from "react";
import Intro from "../../components/intro";
import Section from "../../components/section";
import Sectors from "../../components/sectors";

import Column1 from "../../components/column_1";
import Column2 from "../../components/column_2";
import Column3 from "../../components/column_3";
import PastEditions from "../../components/past_editions";
import ImageText from "../../components/image_text";
import Keen from "../../components/keen";

import ProudAssociation from "../../components/proud_association";
import SignupGravel from "../signup_gravel";
import SignupUltra from "../signup_ultra";
import BannerLink from "../banner_link";
import YoutubeEmbed from "../youtube_embed";
import GalleryEmbed from "../gallery_embed";
import TwoImages from "../two_images";
import Race from "../race";
import LargeImage from "../large_image";
import Routes from "../routes";
import MagnumOpus from "../magnum_opus";

const Page = (props) => {
    const {
        title,
        subtitle,
        _rawIntro,
        intro_black,
        intro_heading,
        cta_text,
        cta_url,
        cta_text_2,
        cta_url_2,
        modules,
        slug,
        path,
    } = props;

    const all_sectors = modules.filter((m) => m._type === "sector");
    const first_sector = modules.findIndex((m) => m._type === "sector");

    return (
        <div>
            <Intro
                cta_text={cta_text}
                cta_url={cta_url}
                cta_text_2={cta_text_2}
                cta_url_2={cta_url_2}
                hero={props.mainImage.asset.publicUrl}
                intro_black={intro_black}
                intro_heading={intro_heading}
                intro={_rawIntro}
                subtitle={subtitle}
                title={title}
                url={`/${slug.current}`}
            />
            {modules.map((module, index) => {
                if (module._type === "past_editions") {
                    return (
                        <PastEditions
                            key={index}
                            past_editions={module.past_edition}
                        />
                    );
                }
                if (module._type === "race") {
                    return <Race key={index} module={module} />;
                }
                if (module._type === "columns_1") {
                    return <Column1 key={index} module={module} />;
                }
                if (module._type === "columns_2") {
                    return <Column2 key={index} module={module} />;
                }
                if (module._type === "columns_3") {
                    return <Column3 key={index} module={module} />;
                }
                if (module._type === "two_images") {
                    return <TwoImages key={index} module={module} />;
                }
                if (module._type === "large_image") {
                    return <LargeImage key={index} module={module} />;
                }
                if (module._type === "magnum") {
                    return <MagnumOpus key={index} module={module} />;
                }
                if (module._type === "routes") {
                    return <Routes key={index} module={module} />;
                }
                if (module._type === "youtube") {
                    return <YoutubeEmbed module={module} />;
                }
                // if (module._type === "gallery_embed") {
                //   return <GalleryEmbed module={module} />;
                // }
                if (module._type === "bannerlink") {
                    return <BannerLink key={index} module={module} />;
                }
                if (module._type === "image_text") {
                    return <ImageText key={index} module={module} />;
                }
                if (module._type === "section") {
                    return <Section key={index} module={module} />;
                }
                if (module._type === "sector" && index === first_sector) {
                    return <Sectors key={index} sectors={all_sectors} />;
                }
                if (module._type === "signup_gravel") {
                    return <SignupGravel key={index} module={module} />;
                }
                if (module._type === "signup_ultra") {
                    return <SignupUltra key={index} module={module} />;
                }
                if (module._type === "slideshow") {
                    return <Keen key={index} module={module} />;
                }
            })}

            {slug.current.includes("gravel") && <ProudAssociation />}
        </div>
    );
};

export default Page;
